const smtTooltipComponent = {
  bgColor: {
    default: 'gray.50',
    _dark: 'gray.700'
  }
};

export default smtTooltipComponent;
